import { Component, ViewChild } from '@angular/core';
import { App, Nav, IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController, ViewController } from 'ionic-angular';

import { MysqlService } from '../../services/mysql.service';
import { ImcpaAppProvider } from '../../providers/imcpaApp/imcpaApp';

import { AddFarmPage } from '../farms/addFarm/addFarm';
import { TabsPage } from '../tabs/tabs';
import { HomePage } from '../home/home';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  // styleUrls: [ 'login.scss', '../../theme/variables.scss' ]
})
export class LoginPage {

  // @ViewChild(Nav) nav: Nav;

  public user = {};
  public access = [];
  public loading;
  public myreturnvalue;

  constructor(public app: App, public viewCtrl: ViewController, public navCtrl: NavController, public myApp: ImcpaAppProvider, public dbService: MysqlService, public loadingCtrl: LoadingController, public toastCtrl: ToastController) {
    // this.getAccess();
  }

  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      content: 'Loading Data, please wait..',
    });
    return await this.loading.present();  
  }

presentToast(type) {
    if(type === "success"){
    const toast = this.toastCtrl.create({
      
      message: "Welcome " + this.access[0].firstname + " " + this.access[0].surname + "!",
      duration: 3000,
      position: 'top',
      cssClass: 'yourClass'
      
    });
    toast.present();
    }
    else if(type === "failure"){
    const toast = this.toastCtrl.create({
      
      message: "Invalid Username Or Password!",
      duration: 3000,
      position: 'top',
      cssClass: 'yourClass'
      
    });
    toast.present();
    }
    
  }

  handleLogin(user){
    this.presentLoading();
    this.dbService.fetchDataV2("select * from access a where a.user = '" + user.username + "' and a.password = '" + user.password + "'")
      .map(res => res.json())
      .subscribe(res => {
        this.access=res.data;
        // console.log(this.access[0].user);
        if(res.data.length === 0){
          this.loading.dismiss();
          this.presentToast("failure")
          // alert("Invalid Username Or Password!"); 
        } else {
          this.myApp.access = this.access[0];
          this.myApp.isLoggedIn = true;
          console.log(this.myApp.access.goshalaId); 
          this.loading.dismiss();
          if(this.access[0].role === 'Farm Manager') {
            this.navCtrl.removeView(this.viewCtrl);
            this.app.getRootNavs()[0].setRoot(AddFarmPage, {from: 'fromLoginPage', goshalaId: this.access[0].goshalaId, type: 'Update Farm'})
            this.presentToast("success")
          } else {
            this.navCtrl.setRoot(TabsPage);
          } 
        }
        }, error => {
        this.loading.dismiss();
        // alert(this.myreturnvalue);
        this.myreturnvalue = "Error: " + error
        alert(this.myreturnvalue);
        console.log(this.myreturnvalue)
        
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts